var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('b-button',{attrs:{"variant":"secondary","pill":""},on:{"click":_vm.submit}},[_vm._v(" Excel خروجی ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }